// Angular Imports
// =========================================================
import { Component } from '@angular/core'
// AG Grid Imports
// =========================================================
import { type ITooltipAngularComp } from 'ag-grid-angular'

@Component({
  standalone: false,
  selector: 'app-metrics-custom-tooltip',
  templateUrl: './metrics-custom-tooltip.component.html',
  styleUrls: ['./metrics-custom-tooltip.component.scss']
})
export class MetricsCustomTooltipComponent implements ITooltipAngularComp {
  params: any
  data: any

  message: string = ''
  tableData: any
  isHeaderCell: boolean = false

  agInit (params): void {
    this.params = params
    const value = params?.value
    // console.log('tool tip params.value:', typeof value)
    this.isHeaderCell = params.location === 'header'

    if (typeof value !== 'string' && value.length > 0) {
      this.tableData = (value as Array<{ count: number, optimal_node: number | null, source: string | null }>)
        .map(item => ({
          source: item.source ?? null,
          prodLevel: item.optimal_node === null ? 'N/A' : item.optimal_node.toString(),
          storesAtLevel: item.count
        }))
        .sort((a, b) => {
          // source='-1' rows always first
          const aIsMinusOne = a.source === '-1'
          const bIsMinusOne = b.source === '-1'
          if (aIsMinusOne && !bIsMinusOne) return -1
          if (!aIsMinusOne && bIsMinusOne) return 1

          // rows with no source go last
          if (a.source && !b.source) return -1
          if (!a.source && b.source) return 1

          // sort by source name
          if (a.source && b.source && a.source !== b.source) {
            return a.source.localeCompare(b.source)
          }

          // within same source, N/A node goes last, then sort numerically
          if (a.prodLevel === 'N/A') return 1
          if (b.prodLevel === 'N/A') return -1
          return Number(a.prodLevel) - Number(b.prodLevel)
        })
    }
    //   console.log('Processed table data:', this.tableData);
  }
}
